import { ReactNode } from 'react';
import { useSearch, useNavigate } from '@tanstack/react-router';
import { SearchFacet } from '#server/models';
import { Header, SearchTabs, Footer } from '@/components';
import { useSearchContext } from '@/context';
import { trackGAEvent } from '@/services';
import { useDeviceType } from '@/hooks';

export interface ResultsLayoutProps {
  mastheadSlot?: ReactNode;
  leftSideBarSlot?: ReactNode;
  mainContentSlot?: ReactNode;
  rightSideBarSlot?: ReactNode;
}

export const ResultsLayout = (props: ResultsLayoutProps) => {
  const navigate = useNavigate();
  const search = useSearch({ strict: false });
  const { setFacet, searchQuery } = useSearchContext();
  const { isDesktop } = useDeviceType();

  const handleTabClick = (value: SearchFacet) => {
    trackGAEvent({
      event: 'search_facet_selected',
      search_facet: value,
      search_term: searchQuery || undefined,
    });
    navigate({
      to: value === 'all' ? '/results' : '/results/$facet',
      params: value === 'all' ? {} : { facet: value },
      search,
    });
    setFacet(value);
  };

  return (
    <div className="bg-white">
      <Header isGlobalHeader isForSearchApplication />
      <div className="m-0 flex h-full w-full flex-col items-center lg:mt-5 lg:px-10">{props.mastheadSlot}</div>
      <SearchTabs isResultsPageMode handleTabClick={handleTabClick} />
      <div className="mx-auto flex h-full w-full max-w-screen-xl flex-row items-start gap-10 px-4 py-8 md:px-6">
        {isDesktop && (
          <div className="scrollbar-thin top-[112px] h-full w-[300px] shrink-0 flex-col px-1.5 pb-2 lg:flex">
            {props.leftSideBarSlot}
          </div>
        )}
        <div className="flex h-full w-full flex-col">{props.mainContentSlot}</div>
        {isDesktop && <div className="h-full w-[300px] shrink-0 flex-col lg:flex">{props.rightSideBarSlot}</div>}
      </div>
      <Footer isFullFooter />
    </div>
  );
};
